import type { Configuration, RedirectRequest, SilentRequest } from '@azure/msal-browser';
import { getRuntimeEnv } from '@utils/runtimeEnv';

const clientId = getRuntimeEnv('REACT_APP_CLIENT_ID');
const tenantId = getRuntimeEnv('REACT_APP_TENANT_ID');
const backendClientId = getRuntimeEnv('REACT_APP_BACKEND_CLIENT_ID');

// Fail fast if anything is missing
if (!clientId) throw new Error('Missing REACT_APP_CLIENT_ID');
if (!tenantId) throw new Error('Missing REACT_APP_TENANT_ID');
if (!backendClientId) throw new Error('Missing REACT_APP_BACKEND_CLIENT_ID');

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: [`api://${backendClientId}/access_as_user`, 'openid', 'profile', 'User.Read'],
  prompt: 'select_account'
};

/**
 * Scopes requested when calling BACKEND API
 */
export const tokenRequest: SilentRequest = {
  scopes: [`api://${backendClientId}/access_as_user`],
};
export const storageScope = `https://storage.azure.com/.default`;